/*
 * cddinodi: Class to handle management of cdds that are in odi format
  Copyright (c) 2025 Quantellia LLC.  All Rights Reserved.
*/
// import $ from 'jquery';

// Note that all-lowercase is so that the file name matches the class name,
// and all-lc is best practice for file names that may live on both windows and *nix
//
// TODO cddinvis and cddinodi should polymorphically inherit from a parent class to avoid
// some of the method redundancy that you see here.
//
export class cddinodi {
  constructor(data) {
    if (data)
      this.data = data;
  }

  parse() {
    // Parse the data
    // TODO complete this stub
    alert("model parse");
  }

  validate() {
    // Validate the model
    // TODO complete this stub
    alert("model validate");
  }


  async read() {
    // TODO: This sets data to be a string, not an object. Is that correct?  Is it consistent
    // with write()?
    return new Promise((resolve, reject) => {
      const fileInput = document.createElement("input");
      fileInput.type = "file";

      fileInput.addEventListener("change", (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile) {
          const fileReader = new FileReader();

          fileReader.onload = (event) => {
            this.data = event.target.result; // Attach data to the instance
            resolve();
          };

          fileReader.readAsText(selectedFile);
        }
      });

      fileInput.click();
    });
  }

  async write() {
    // TODO magic constant needs to be in config
    const DEFAULTODIFILENAME = "mymodel.odi";

    if (!this.data) {
      // TODO needs better error handling
      console.log("No odi format cdd data to write");
      return;
    }

    return new Promise((resolve, reject) => {
      const dataToWrite = this.data; 

      if (dataToWrite) {
        const blob = new Blob([dataToWrite], { type: "text/plain" });

        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = DEFAULTODIFILENAME;

        a.addEventListener("click", () => {
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
          }, 150); // Revoke the object URL after a short delay to ensure the file is downloaded

          resolve();
        });

        a.click();
      } else {
        reject("No data to write.");
      }
    });
  }

  transform() {
    // Transform the model
    alert("model transform");
  }

  // TODO may belong in a diView component, not here
  render() {
    // Render the model
    alert("model render");
  }
}

///
// Utilities
///
